import EnkRoutes from "./routes"

function App() {
  return <EnkRoutes />
}

export default App
